import { USER_TYPE } from '../../constants/userConstants';
var isSns = function (userType) {
    switch (userType) {
        case USER_TYPE.FACEBOOK:
        case USER_TYPE.TWITTER:
        case USER_TYPE.NAVER:
        case USER_TYPE.KAKAO:
        case USER_TYPE.INSTAGRAM:
        case USER_TYPE.APPLE:
            return true;
        default:
            return false;
    }
};
export default isSns;
